export default __webpack_public_path__ + "static/media/logos-juntos-footer.5d344e62.svg";